"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var CONSTANTS = {
  PRODUCT_MARKETPLACE_SUPPORT_EMAIL: 'ProductMarketplaceSupport@cimpress.com',
  REQUIRED_INPUTS_URL: 'https://priceinput.ff.cimpress.io/api/v1/requiredinputs',
  REFERENCEID_RULESET_URL: 'https://rule.products.cimpress.io/v1/ruleSets',
  MCPSKU: 'McpSku',
  QUANTITY: 'quantity',
  DESTINATION: 'destination',
  COUNTRY: 'country',
  TENANT: 'tenant',
  PRODUCT: 'product',
  ORDER: 'order',
  PRODUCTION_TIME: 'production time',
  MSG_NO_REQ_ATTRIBUTE: 'No selections are required for this product to calculate price.',
  MSG_NO_REQ_ATTRIBUTE_ERROR: 'There are no required attributes for this product. There may not be any contract associated with this product.',
  LISTOFVALUES: 'listOfValues',
  LISTOFRANGES: 'listOfRanges',
  FORMULA: 'formula',
  VALUES: 'values',
  ANY: 'any',
  RANGES: 'ranges',
  FULLY_RESOLVED: 'fullyResolved',
  PARTIALLY_RESOLVED: 'partiallyResolved',
  ON_LOAD: 'onLoad',
  UNRESOLVABLE: 'unresolvable',
  ATTRIBUTESELECTORPRICING: 'attributeSelectorPricing',
  ENTER_KEY_CODE: 13,
  CATALOG_ROOT: 'CAT-00000',
  MCPSKU_CLASSES: ['order', 'tenant']
};
var _default = CONSTANTS;
exports["default"] = _default;